import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import {
    AppNotificationService,
    AppNotificationType,
    MaterialInventoryModel,
    OdataMaterialService,
    UserMasterService,
} from '@evorait/pace-core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

@Component({
    selector: 'pace-material-inventory',
    templateUrl: './material-inventory.component.html',
    styleUrls: ['./material-inventory.component.scss'],
})
export class MaterialInventoryComponent implements OnInit {
    public model: MaterialInventoryModel | undefined;

    public isLoading = true;
    public constructor(
        private readonly translate: TranslateService,
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        public readonly modalInstance: BsModalRef,
        private readonly appNotificationService: AppNotificationService,
        private readonly userMasterService: UserMasterService,
        private readonly odataMaterialService: OdataMaterialService,
    ) {}

    public ngOnInit(): void {
        const userMasterData = this.userMasterService.getSelectedUserModel();
        this.odataMaterialService
            .getMaterialInventory(userMasterData)
            .pipe(
                take(1),
                map((response) => {
                    this.model = response;
                    this.isLoading = false;
                }),
                catchError((error) => {
                    this.model = new MaterialInventoryModel([]);
                    this.log.error('Error in getting Material Inventory', error);
                    this.appNotificationService.setAppNotification(
                        AppNotificationType.ERROR,
                        <string>this.translate.instant('MATERIAL_REQUEST_ERROR_TITLE'),
                        error instanceof HttpErrorResponse
                            ? `${error.status} : ${error.statusText}`
                            : JSON.stringify(error),
                    );
                    this.modalInstance.hide();
                    return of(undefined);
                }),
                map(() => {
                    this.isLoading = false;
                }),
            )
            .subscribe();
    }
}
